/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const CheckSquareIcon: React.FC<AllieIconProps> = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g id="check-square">
      <path
        id="Icon"
        d="M9.1875 11.0625L12 13.875L21.375 4.5M20.4375 12V18.5625C20.4375 19.0598 20.24 19.5367 19.8883 19.8883C19.5367 20.24 19.0598 20.4375 18.5625 20.4375H5.4375C4.94022 20.4375 4.46331 20.24 4.11167 19.8883C3.76004 19.5367 3.5625 19.0598 3.5625 18.5625V5.4375C3.5625 4.94022 3.76004 4.46331 4.11167 4.11167C4.46331 3.76004 4.94022 3.5625 5.4375 3.5625H15.75"
        stroke="white"
        strokeWidth="1.875"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
  </svg>
);
